module.exports = __webpack_public_path__ + "img/Cross.1375b9ec.svg";